// 検索条件を共有するためのState (URLへの反映は別途)
import type { QueryFavorite } from "~/types/entity/cWebCatalog";

const getDefaultValue = (): QueryFavorite => ({
  tab: 1,
  sort: undefined,
  favorite: undefined,
  day: undefined,
  wcid: undefined,
});

export type TabLabel = "CIRCLE" | "BOOTH"
export const tabValueCircle: TabLabel = "CIRCLE";
export const tabOrderCircle: number = 1;
export const tabValueBooth: TabLabel = "BOOTH";
export const tabOrderBooth: number = 2;

export const useQueryFavoriteState = () => {
  const state = useState<QueryFavorite>("queryFavorite", getDefaultValue);

  const reset = () => {
    state.value = getDefaultValue();
  };

  // アプリケーション内でグローバルな state の操作は影響範囲が大きいので 手軽に使える値の操作として公開せず
  // 関数呼び出しとして見せる
  return {
    /**
     * パラメータとして取得する
     */
    get: () => state.value,
    /**
     * パラメータを更新する
     * @param v
     * @returns
     */
    set: (v: QueryFavorite) => state.value = v,
    /**
     * 初期状態に戻す
     * ただし一部の値を維持することがある (例えば event_id)
     *
     * 1関数内で 他の値設定を続いて呼び出した場合 画面の再描画されないことが期待できる
     */
    reset,
    setTab: (v: number) => state.value.tab = v,
  };
};
